export const getPipelineId = report => report.getIn(['config', 'pipeline', 'id']);
export const getPipelineStages = report => report.getIn(['config', 'pipeline', 'stages']);